import { z } from 'zod';

export const revenueExpenseReportSchema = z.object({});

export type EditPrintTemplateTableType = object;

export const editPrintTemPlateSchema = z.object({});

export type EditPrintTemplateFormValues = z.infer<typeof editPrintTemPlateSchema>;

export const searchSchema = z.object({
  ma_qg: z.string().min(1, 'Mã quốc gia là bắt buộc'),
  ten_qg: z.string().min(1, 'Tên quốc gia là bắt buộc'),
  ten_qg2: z.string().optional().nullable(),
  status: z.number().default(1)
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export interface CountryFormattedData {
  ma_qg: string;
  ten_qg: string;
  ten_qg2: string | null;
  status: string | number;
}
